import { useCallback, useMemo } from "react";

import { DropDownList } from "../../dropDownList";
import { Props } from "./types";

const ALL_VALUE = -1;
export function FilterDropdown(props: Props) {
	const { objectName } = props;
	const allTitle = props.allTitle ?? `All ${objectName}`;
	const defaultProps = {
		valueProp: "id",
		textProp: "value",
		label: `${objectName}`,
		displayAll: false,
		placeholder: props.allTitle ?? allTitle,
	} as Props;
	const { allOption = false, valueProp, textProp } = { ...defaultProps, ...props };

	const allOptionValue = useMemo(() => {
		const obj = {};
		obj[valueProp] = ALL_VALUE;
		obj[textProp] = allTitle;
		return obj;
	}, [allTitle, valueProp, textProp]);

	const values = useMemo(() => {
		if (!props.values) return [];
		if (!allOption) return props.values;
		return [allOptionValue, ...props.values];
	}, [props.values, allOption, allTitle]);

	const value = useMemo(() => {
		if (!allOption) return props.value;
		if (props.isMulti && !props.value?.length) return [ALL_VALUE];
		else if (!props.value) return ALL_VALUE;
		return props.value;
	}, [props.value, allOption, allOptionValue, props.isMulti]);

	const onChange = useCallback(
		(v: any) => {
			return props.changeHandler(v, props.id ?? props.name);
		},
		[props.changeHandler, props.id, props.name],
	);

	const multiChangeHandler = useCallback(
		(v: any[]) => {
			const allSelected = v?.includes(ALL_VALUE);
			if (!allSelected) return onChange(v);

			const actualValues = v.filter((v) => v !== ALL_VALUE);
			if (props.value?.length) return onChange([]);
			return onChange(actualValues);
		},
		[onChange, props.value],
	);

	const singleChangeHandler = useCallback(
		(v) => {
			if (v === ALL_VALUE) return onChange(null);
			return onChange(v);
		},
		[onChange],
	);

	const changeHandler = useCallback(
		(v) => {
			if (!allOption) return onChange(v);
			if (props.isMulti) return multiChangeHandler(v);
			return singleChangeHandler(v);
		},
		[onChange, singleChangeHandler, multiChangeHandler, props.isMulti],
	);
	const label = props.label ?? defaultProps.label;
	return (
		<DropDownList
			{...defaultProps}
			{...props}
			label={label}
			value={value}
			changeHandler={changeHandler}
			values={values}
		/>
	);
}
